import { logError } from '@/src/utils/logError'
import { useEffect, useRef } from 'react'

const useStepScrollToTop = (isStepActive: boolean) => {
    const stepRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        try {
            if (isStepActive && stepRef.current) {
                // Small delay to ensure the step content has rendered
                setTimeout(() => {
                    if (stepRef.current) {
                        const headerHeight = 54 // Fixed header height
                        const elementRect = stepRef.current.getBoundingClientRect()
                        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
                        const targetPosition = scrollTop + elementRect.top - headerHeight - 16 // 16px spacing below header

                        window.scrollTo({
                            top: Math.max(0, targetPosition),
                            behavior: 'smooth'
                        })
                    }
                }, 100)
            }
        } catch (error) {
            logError('useStepScrollToTop', error)
        }
    }, [isStepActive])

    return stepRef
}

export default useStepScrollToTop
